import { render } from "./SingleNavigation.vue?vue&type=template&id=29f41fb6&ts=true"
import script from "./SingleNavigation.vue?vue&type=script&lang=ts"
export * from "./SingleNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__